import cargoAPI from '@/services/api/cargo'
import _ from 'lodash'
import { FindClassification, Classification } from '@/utils/defines/ItemCode'
import categoryAPI from '@/services/api/category'

const state = {
	cargoFormType: 'ADD', // ADD, EDIT, NEED_INPUT_LIST, NEED_INPUT_DETAIL(입력필요)
	cargoInfo: {
		multiCreateCount: 1,
	},
	category: null,
	categoryInfo: null,
	categoryDetail: null,
	uploadMsds: null,
	isAutoCargo: false, // 자동 입고 여부
	recentRegistCargoId: null, // 자동 입고시 사용할 registCargoId
}

const findFieldIdxByKeyName = keyname =>
	state.categoryInfo?.fields?.inventoryFields?.findIndex(
		it => it.key == keyname
	)

const getters = {
	cargoFormType: state => state.cargoFormType,
	cargoInfo: state => state.cargoInfo,
	category: state => state.category,
	categoryInfo: state => {
		const categoryInfo = _.cloneDeep(state.categoryInfo)
		const currentVolumeIndex = findFieldIdxByKeyName('currentVolume')
		const volumeIndex = findFieldIdxByKeyName('volume')
		if (
			categoryInfo?.classification === Classification.CHEMICAL &&
			currentVolumeIndex !== -1
		) {
			categoryInfo.fields.inventoryFields[currentVolumeIndex].unit =
				categoryInfo?.fields?.inventoryFields[volumeIndex].unit
		}
		return categoryInfo
	},
	multiCreateCount: state => state?.cargoInfo?.multiCreateCount,
	cargoFormData: state => {
		if (state.category) {
			const formData = new FormData()
			console.warn()
			Object.entries(state.cargoInfo).forEach(([key, value]) => {
				if (value) {
					if (
						[
							'EDIT',
							'NEED_INPUT_LIST',
							'NEED_INPUT_DETAIL',
						].includes(state.cargoFormType) &&
						[
							'storage',
							'register',
							'assignee',
							'msds',
							'status',
							'category',
							'legalList',
							'image',
						].includes(key)
					) {
						return
					}
					switch (key) {
						case 'ingredient':
							if (value.length === 0) {
								formData.append(key, '')
							} else {
								value.forEach((item, idx) => {
									formData.append(
										`${key}[${idx}][name]`,
										item.name
									)
									formData.append(
										`${key}[${idx}][ratio]`,
										item.ratio
									)
									if (item.casno) {
										formData.append(
											`${key}[${idx}][casno]`,
											item.casno
										)
									}
								})
							}
							break
						case 'images':
							value.forEach(item =>
								formData.append(`${key}`, item)
							)
							break
						case 'tagsId':
							// 편집시 데이터 없는 경우
							if (value.length === 0) {
								formData.append(key, '')
							} else {
								value.forEach(item =>
									formData.append(`${key}[]`, item)
								)
							}
						case 'deleteImages':
						case 'qrSticker':
							if (value.length === 0) {
								formData.append(key, '')
							} else {
								value.forEach(item =>
									formData.append(`${key}[]`, item)
								)
							}
							break
						case 'ghs':
							value.dangerCode.forEach((item, idx) => {
								formData.append(`ghs[dangerCode][${idx}]`, item)
							})
							value.precautionCode.forEach((item, idx) => {
								formData.append(
									`ghs[precautionCode][${idx}]`,
									item
								)
							})
							let { address, name, phone } = value.provider
							formData.append(`ghs[provider][address]`, address)
							formData.append(`ghs[provider][name]`, name)
							formData.append(`ghs[provider][phone]`, phone)
						default:
							formData.append(key, value)
							break
					}
				}
			})
			if (state.uploadMsds) {
				formData.append('msds', state.uploadMsds)
			}
			return formData
		} else {
			return null
		}
	},
	isProductValid: state => {
		if (state.categoryInfo) {
			const requireFields = state.categoryInfo?.fields.inventoryFields
				.filter(f => f.isActive && !f.readOnly && f.isRequire)
				.map(item => item.key)
			const useUnitFields = state.categoryInfo?.fields.inventoryFields
				.filter(
					f =>
						(f.isActive && !f.readOnly && f?.unit?.length > 0) ||
						f.key === 'currentVolume'
				)
				.map(item => item.key)
			let isRequireData = true
			requireFields.forEach(requireKey => {
				// 필수 값인 경우
				if (!state.cargoInfo[requireKey]) {
					isRequireData = false
				}
			})

			// Unit이 있는 값인 경우
			useUnitFields.forEach(unitKey => {
				if (
					state.cargoInfo[unitKey] &&
					!state.cargoInfo[`${unitKey}Unit`]
				) {
					// 값은 있지만 Unit이 없는 경우
					isRequireData = false
				}
			})

			return isRequireData
		} else return false
	},
	isIngredientValid: state => {
		if (state.cargoInfo.ingredient) {
			return (
				state.cargoInfo.ingredient.find(i => !i.name || !i.ratio) ===
				undefined
			)
		} else return true
	},
	isManagementValid: state => {
		if (state.categoryInfo) {
			const requireFields = state?.categoryInfo?.fields.managementFields
				.filter(f => f.isActive && !f.readOnly && f.isRequire)
				.map(item => item.key)
			let isRequireData = true
			const useUnitFields = state.categoryInfo?.fields.managementFields
				.filter(f => f.isActive && !f.readOnly && f?.unit?.length > 0)
				.map(item => item.key)
			requireFields.forEach(requireKey => {
				// 필수 값인 경우
				if (!state.cargoInfo[requireKey]) {
					isRequireData = false
				}
			})

			// Unit이 있는 값인 경우
			useUnitFields.forEach(unitKey => {
				if (
					state.cargoInfo[unitKey] &&
					!state.cargoInfo[`${unitKey}Unit`]
				) {
					// 값은 있지만 Unit이 없는 경우
					isRequireData = false
				}
			})

			return isRequireData
		} else return false
	},
	isCategoryId: state => state.categoryInfo?.id,
}

const mutations = {
	setInitCargoInfo: state => {
		state.cargoInfo = {
			multiCreateCount: 1,
		}
		state.category = null
		state.categoryInfo = null
		state.isAutoCargo = false
		state.recentRegistCargoId = null
		state.uploadMsds = null
	},
	setCargoInfo: (state, cargoInfo) => {
		state.cargoInfo = cargoInfo
	},
	setCategory: (state, category) => {
		state.category = category
		if (category) {
			state.cargoInfo.categoryType = category.type
			state.cargoInfo.categoryId = category.id
		}
	},
	setCategoryType: (state, categoeyType) => {
		state.cargoInfo.categoryType = categoeyType
	},
	setMultiCreateCount: (state, count) => {
		state.cargoInfo.multiCreateCount = count
	},
	setCategoryInfo: (state, categoryInfo) => {
		state.categoryInfo = categoryInfo
	},
	setIngredientInfo: (state, ingredient) => {
		const cargoInfo = { ...state.cargoInfo }
		cargoInfo.ingredient = ingredient
		state.cargoInfo = cargoInfo
	},
	setMsds: (state, msds) => {
		state.uploadMsds = msds
	},
	setAutoCargo: (state, isAutoCargo) => {
		state.isAutoCargo = isAutoCargo
	},
	setRecentRegistCargoId: (state, cargoId) => {
		state.recentRegistCargoId = cargoId
	},
	setCargoFormType: (state, formType) => {
		state.cargoFormType = formType
	},
}

const actions = {
	getCategoryInfo: async ({ commit, rootGetters }, categoryId) => {
		const response = await cargoAPI.getCategoryInfo(
			rootGetters.instituteId,
			{
				id: categoryId,
			}
		)
		commit('setCategoryInfo', response.data)
	},
	getCategoryFieldsByType: async ({ commit, rootGetters }, categoryType) => {
		const response = await categoryAPI.getCategoryFieldsByType(
			rootGetters.instituteId,
			{ type: categoryType }
		)
		commit('setCategoryInfo', {
			classification: FindClassification(categoryType),
			type: categoryType,
		})
	},
	selectCategory: async ({ commit, dispatch }, category) => {
		if (category) {
			commit('setCategory', category)
			if (category.id) {
				dispatch('getCategoryInfo', category.id)
			} else {
				dispatch('getCategoryFieldsByType', category.type)
			}
		}
	},
	registCargo: async (
		{ rootGetters, state, getters, commit, dispatch },
		registerMethod
	) => {
		getters.cargoFormData.append('registerMethod', registerMethod)
		const response = await cargoAPI.registCargo(
			rootGetters.instituteId,
			getters.cargoFormData
		)
		if (state.isAutoCargo) {
			await commit('setRecentRegistCargoId', response.data?.id)
			await dispatch('processCargoItem')
		}
	},
	processCargoItem: async ({ rootGetters, state }) => {
		await cargoAPI.processCargoItem(rootGetters.instituteId, {
			ids: [state.recentRegistCargoId],
		})
	},
	setForm: async ({ commit, state, dispatch }, item) => {
		commit('setCargoInfo', item)
		if (item.category) {
			dispatch('selectCategory', {
				...item.category,
				classification: FindClassification(item.category.type),
			})
		} else {
			dispatch('selectCategory', {
				type: item.categoryType,
				classification: FindClassification(item.categoryType),
			})
		}
	},
	editCargo: async ({ rootGetters, getters }) => {
		await cargoAPI.editCargo(rootGetters.instituteId, getters.cargoFormData)
	},
}
export default { namespaced: true, state, getters, mutations, actions }
